import connexion from "./modules/connexion";
import role from "./modules/role";
import permissions from "./modules/permissions";
import categorie from "./modules/categorie";
import user from "./modules/user";
import sousCategorie from "./modules/sousCategorie";
import typeFile from "./modules/typeFile";
import demande from "./modules/demande";
import fichierController from "./modules/fichierController";
import actualite from "./modules/actualite";
import societe from "./modules/societe";
import fonction from "./modules/fonction";
import dirigeant from "./modules/dirigeant";
import demandeSociete from "./modules/demandeSociete";
import message from "./modules/message";
import newsletter from "./modules/newsletter";
import uploadFile from "./modules/uploadFile";
import banque from "./modules/banque";
import cotisation from "./modules/cotisation";
import formation from "./modules/formation";
import logs from "./modules/logs";
import commission from "./modules/commission";
import stagiaire from "./modules/stagiaire";
import rapport from "./modules/rapport";
import presence from "./modules/presence";
import comitePosition from "./modules/comite-position";
import comiteMembre from "./modules/comite-membre";
import album from "./modules/album";
import document from "./modules/document";
import video from "./modules/video";
import setting from "./modules/setting";
import finance from "./modules/finance";
import fichierExpert from "./modules/fichierExpert";
import soldePrecedent from "./modules/soldePrecedent";
import chambreCommission from "./modules/chambreCommission";


const store = {
  modules: {
    connexion: connexion,
    user: user,
    permissions: permissions,
    role: role,
    categorie: categorie,
    sousCategorie: sousCategorie,
    typeFile: typeFile,
    demande: demande,
    fichierController: fichierController,
    actualite: actualite,
    societe: societe,
    fonction: fonction,
    dirigeant: dirigeant,
    demandeSociete: demandeSociete,
    message: message,
    newsletter: newsletter,
    uploadFile: uploadFile,
    banque: banque,
    cotisation: cotisation,
    formation: formation,
    logs: logs,
    commission: commission,
    stagiaire: stagiaire,
    rapport: rapport,
    presence: presence,
    comitePosition: comitePosition,
    comiteMembre: comiteMembre,
    album: album,
    document: document,
    video: video,
    setting: setting,
    finance: finance,
    fichierExpert: fichierExpert,
    soldePrecedent: soldePrecedent,
    chambreCommission: chambreCommission,
  },
};

export default store;
